import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import type {
  AppDispatch,
  IMonthBucket,
  ITripTerminus,
} from "@b2bportal/core-types";
import { useEnablePricePrediction } from "@b2bportal/core-utilities";
import type { TripCategory } from "@overrides/types";
import {
  getPricePredictionDepartureMonthsForSlice,
  getPriceTagsForSlice,
  isFlightPredictionLoadingForSlice,
} from "../store";
import { fetchCalendar } from "../store/thunks";

export const useFetchCalendar = ({
  origin,
  destination,
  tripCategory,
  sliceIndex,
}: {
  origin?: ITripTerminus;
  destination?: ITripTerminus;
  tripCategory?: TripCategory;
  // For multicity flights, indicates which slice (leg) to fetch calendar data for
  sliceIndex?: number;
}): {
  departureMonths: IMonthBucket[];
  priceTags: string[];
  isLoading: boolean;
} => {
  const isEnabled = useEnablePricePrediction();

  // Use slice-specific selectors for multicity flights
  const isLoading = useSelector(isFlightPredictionLoadingForSlice(sliceIndex));
  const priceTags = useSelector(getPriceTagsForSlice(sliceIndex));
  const departureMonths = useSelector(
    getPricePredictionDepartureMonthsForSlice(sliceIndex)
  );
  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    if (
      origin?.id?.code != null &&
      destination?.id?.code != null &&
      tripCategory != null &&
      isEnabled
    ) {
      dispatch(
        fetchCalendar({ origin, destination, tripCategory, sliceIndex })
      );
    }
  }, [
    origin?.id?.code,
    destination?.id?.code,
    tripCategory,
    sliceIndex,
    isEnabled,
  ]);

  return {
    departureMonths,
    priceTags,
    isLoading,
  };
};
